<template>
  <div>
    <!-- <div style="-webkit-filter: grayscale(100%);filter: grayscale(100%);"> -->
    <section class="header">
      <header1 :index="1"></header1>
    </section>

    <van-swipe
      class="my-swipe"
      :autoplay="1000000"
      style="height: 185px"
      indicator-color="white"
      v-if="headline.length > 0"
    >
      <!--      <van-swipe-item v-for="(item, k) in headline" :key="k">
        <div class="thumb" @click="goThumb(item.id)">
          <van-image :src="item.titleImgUrl"></van-image>
          <div class="title">{{ item.title }}</div>
        </div>
      </van-swipe-item>-->
      <van-swipe-item v-for="(item, k) in headline" :key="k">
        <div class="thumb" @click="goView(item)">
          <van-image
            :src="item.fullwidthTopUrl"
            style="aspect-ratio: 2/1"
          ></van-image>
          <div class="title">{{ item.title }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div>
      <div class="main" v-if="hottalk.length && isHome === 1">
        <div class="jingxuan">
          <div class="titles">
            <!-- <i class="iconfont icon-jingxuan"></i>  -->
            <svg
              t="1637114280460"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13925"
              width="15"
              height="15"
            >
              <path
                d="M754.272 433.696 497.92 689.92C489.184 698.912 476.864 704 463.968 704 451.04 704 438.72 698.912 429.984 689.92L269.728 529.792C251.424 510.432 251.424 481.184 269.728 461.824 278.144 453.472 289.664 448.544 301.856 448.128 315.36 447.52 328.48 452.512 337.728 461.824L463.968 588 686.304 365.792C695.168 356.992 707.456 352 720.288 352 733.152 352 745.408 356.992 754.272 365.792 772.576 385.12 772.576 414.368 754.272 433.696M895.872 0 128.128 0C57.248 0 0 57.376 0 128.16L0 895.872C0 966.752 57.376 1024 128.128 1024L895.872 1024C966.752 1024 1024 966.656 1024 895.872L1024 128.16C1024 57.248 966.624 0 895.872 0"
                p-id="13926"
                fill="#d41901"
              ></path>
            </svg>
            关注
          </div>
          <div class="topNew">
            <div v-swiper:mySwiper="swiperOptions">
              <div class="swiper-wrapper">
                <div
                  @click="goView(i)"
                  class="swiper-slide"
                  v-for="(i, k) in hottalk"
                  :key="k"
                >
                  <div class="item">
                    <div class="contents">
                      <div class="subject">
                        {{ i.title }}
                      </div>
                      <div class="simple-desc">
                        {{ i.summary }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <news
        :newList="newList"
        :malaList="malaList"
        :showBanner="true"
        :showMalaList="showMalaList"
      ></news>
      <div class="loading" v-if="loadingC">
        <van-loading type="circular" color="#999" />
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="page > 1">
        <span slot="no-more" style="font-size: 10px">没有内容了。</span>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import header1 from "@/components/header4";
import news from "@/components/news";
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { getList, getTonglan, getMalaToutiao } from "../commJs/api";
import { getHotArticlesList } from "../commJs/articles";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    header1,
    news,
    InfiniteLoading,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      page: 1,
      newList: [],
      cid: null,
      current: 0,
      headline: [],
      loadingC: false,
      jingxuan: [],
      isHome: null,
      malaList: [],
      hottalk: [],
      swiperOptions: {
        slidesPerView: "auto",
        loop: false,
        spaceBetween: 10,
      },
      showMalaList: false,
      lastId: 0,
    };
  },

  mounted() {},
  watch: {
    cid: {
      handler(newVal) {
        if (newVal === 1) {
          this.showMalaList = true;
          this.malaList = [];
          getMalaToutiao().then((res) => {
            if (res.code == 200) {
              this.malaList = res.list;
            }
          });
        }
      },
    },
    $route: {
      handler() {
        let cid = this.$route.params.id;
        this.cid = Number(this.$route.params.id);
        let isHomepage = this.$route.query.isHomepage;
        if (isHomepage == null) {
          try {
            const tab = JSON.parse(localStorage.getItem("navActive") || "{}");
            if (String(tab.id) === String(cid)) {
              isHomepage = tab.isHomepage;
            }
          } catch (e) {
            // ignore
          }
        }
        this.isHome = Number(isHomepage);
        this.getIndex(cid, isHomepage);
      },
      immediate: true,
    },
  },
  methods: {
    // Tonglan(){
    //
    // },
    goView(item) {
      const { id, type: t, externalLink } = item;
      if (t === 5) {
        if (externalLink) {
          window.open(externalLink, "_blank", "noopener,noreferrer");
        }
        return;
      }
      if (t === 1) {
        this.$router.push({ name: "news", params: { id: id } });
      } else if (t === 3) {
        this.$router.push({ name: "live", params: { id: id } });
      } else if (t === 2) {
        this.$router.push({ name: "topic", params: { id: id } });
      } else {
        this.$router.push({ name: "news", params: { id: id } });
      }
    },
    goThumb(id) {
      this.$router.push({ name: "news", params: { id: id } });
    },
    onChange(index) {
      this.current = index;
    },
    dateFormat(val) {
      if (val != null) {
        var date = new Date(val);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate()
        );
      }
    },

    getHeadlineIdSet() {
      const ids = new Set();
      this.headline.forEach((item) => {
        if (item && item.id != null) ids.add(item.id);
      });
      return ids;
    },
    getExcludedIdSet() {
      const ids = this.getHeadlineIdSet();
      this.hottalk.forEach((item) => {
        if (item && item.id != null) ids.add(item.id);
      });
      return ids;
    },
    filterNewsList(list) {
      const excludeIds = this.getExcludedIdSet();
      return (list || []).filter((item) => !excludeIds.has(item.id));
    },
    infiniteHandler($state) {
      let _this = this;
      getList({
        categoryId: this.cid,
        rows: 20,
        page: parseInt(this.page),
      }).then((res) => {
        if (res.success === "true") {
          const rawList = res.data.list || [];
          if (rawList.length === 0) {
            $state.complete();
          } else {
            this.page = this.page + 1;
            if (this.lastId !== rawList[0].id) {
              const filtered = _this.filterNewsList(rawList);
              if (filtered.length > 0) {
                _this.newList = _this.newList.concat(filtered);
              }
              this.lastId = rawList[0].id;
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        }
      });
    },
    getDateDiff(date) {
      var result = this.dateFormat(new Date(date).getTime());
      return result;
    },
    async getIndex(cid, isHomepage) {
      let _this = this;
      if (cid) this.cid = cid;
      _this.newList = [];
      this.page = 1;
      this.lastId = 0;
      this.headline = [];
      _this.loadingC = true;
      _this.hottalk = [];

      try {
        const tonglanRes = await getTonglan({
          categoryId: this.cid,
          row: Number(isHomepage) === 1 ? 3 : 1,
        });
        if (tonglanRes.success === "true") {
          _this.headline = tonglanRes.data || [];
        }

        if (Number(cid) === 1) {
          try {
            const list = await getHotArticlesList();
            const headlineIds = _this.getHeadlineIdSet();
            _this.hottalk = (list || []).filter(
              (item) => !headlineIds.has(item.id),
            );
          } catch (e) {
            _this.hottalk = [];
          }
        }

        const listRes = await getList({
          categoryId: this.cid,
          rows: 20,
          page: 1,
        });
        if (listRes.success === "true") {
          const rawList = listRes.data.list || [];
          this.page = this.page + 1;
          _this.newList = _this.filterNewsList(rawList);
          if (rawList.length > 0) {
            this.lastId = rawList[0].id;
          }
        }
      } finally {
        _this.loadingC = false;
      }
    },
  },
};
</script>
<style lang="less">
.swiper-slide {
  width: 70% !important;
  //margin-right:20px;
  background: #fff;

  .item {
    min-height: 3rem;
    margin-bottom: 4px;
    padding-bottom: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }
}
.swiper-wrapper {
  margin: 0 10px;
}

.thumb .van-image {
  img {
    object-fit: cover;
  }
}
</style>
<style scoped lang="less">
.newsList {
  padding: 10px 15px;

  .labletitle {
    // font-family: caoshu1;
    font-size: 18px;
    color: #323953;
  }
}

.fullthumb {
  line-height: 0;
  display: none;
}

.main {
  .jingxuan {
    .titles {
      // font-family: caoshu;
      font-size: 18px;
      //font-weight: bold;
      color: #e92129;
      padding: 8px 15px;
    }

    .iconfont {
      color: #e5444b;
    }
  }
}

.topNew {
  .subject {
    font-size: 14px;
    font-weight: bold;
    color: #323953;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 10px;
    overflow: hidden;
  }

  .contents {
    padding: 7px 15px;
  }

  .simple-desc {
    font-size: 14px;
    color: #999;
    //padding: 5px 15px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  img {
    object-fit: cover;
  }
}

.my-swipe {
  padding: 10px 10px 0 10px;
  width: calc(100% - 20px);
  overflow: hidden;
}

.my-swipe .thumb {
  position: relative;
  height: 185px;
  width: calc(100% - 20px);
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0;
    background-color: transparent;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(#000)
    );
    background: -webkit-linear-gradient(top, transparent, #000);
    background: -moz-linear-gradient(top, transparent, #000);
    background: -ms-linear-gradient(top, transparent, #000);
    opacity: 0.6;
  }

  .title {
    color: #fff;
    position: absolute;
    bottom: 20px;
    z-index: 1111;
    left: 10px;
    font-size: 18px;
    width: calc(100 - 20px);
  }
}

.cards {
  .thumb {
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .content {
    padding: 15px;

    .subject {
      color: rgb(21 73 154);
      font-size: 18px;
      font-weight: 700;
    }

    .simple-desc {
      margin: 10px 0;
      color: #999;
      font-size: 14px;
    }
  }
}
</style>
